import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationSearchEntities = <T>(entityRoot: string) => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (nameFilter: string) => {
      if (nameFilter == null || nameFilter.length === 0) {
        return [];
      }

      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/${entityRoot}?name=${nameFilter}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to search for ${entityRoot}`);
      }

      const json = (await response.json()) as { data?: T[] };

      return json?.data ?? [];
    },
    {
      onError: (error, data) => {
        console.error(`Failed to search for ${entityRoot}`, error, data);
      },
    },
  );
};
